import { GetterTree } from 'vuex';
import { AnnouncementState, RootState } from '../types';

export const getters: GetterTree<AnnouncementState, RootState> = {
	getAnnouncements(state): Announcement[] {
		return state.announcements;
	}
};